import { animationsList, fadeIn, fadeOut, transformIn, transformOut, expandHeight, collapseHeight, expandWidth, collapseWidth } from "./_animations.mjs"; // import the animations from our animations script so the disclosure script can use them when toggling elements on the page
import { Disclosure } from './_disclosure.mjs';

//todo: allow for more specific grouping of disclosure elements
//todo: When a nested accordion item is accessed from a control outside the accordion, but accordion item's parent is closed, open the accordion parent accordion item, but only if the toggle button is used to open the content.
//todo: opening a nested dropdown with keyboard, and then clicking outside it doesn't update the state of the nested dropdown properly

// Javascript-Powered Accordion script for the displaying and hiding of elements within an accordion widget, and update their corresponding accordion headers
// @author Jesse de Vries

    'use strict';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)'); //todo: We already declare this in _disclosure.mjs

    /**
     * Accordion
     * @author Jesse de Vries
    */
    function Accordion(options) {
        this.Init(options);
    }

    /**
     * Constructor
     * @Param object options
     * @return void
     */
    Accordion.prototype = {

        // Initialize Object variables
        Init: function (options) { // Initialization

            // Default selectors
            this.options = Object.assign({
                controls: '.js-accordion-header', // Controls (buttons) used to toggle elements. The reason we need to assign this is that we only want accordion headers to implement accordion-like behavior. This way regular disclosure controls nested inside an accordion still work as intended. Keep in mind that both regular disclosure controls and accordion headers still need [data-disclosure-control] applied to them
            }, options);

            // Initialize Prototype variables
            this.controls = document.querySelectorAll(this.options.controls);

            this.SetEvents();
        },

        /**
         * SetEvents
         * @return void
         */
        // Event Handling
        SetEvents: function () {

            // Create local variables from the Object context
            const controls = this.controls;
            // todo: should this be debounced?
            controls.forEach(function(control) { // Iterate through all .js-accordion-header elements
                control.addEventListener('click', function() { // todo: consider using Event delegation here
                    fireEvent(this); // Jump to 'fireEvent', passing with it the instance of the button that was clicked and its type as arguments
                });

                control.addEventListener('keydown', function (e) {
                    setKeyboardControls(this, e);
                });

            });

            function setKeyboardControls(control, e) {
                const accordion = control.closest('.js-accordion'); // Get the nearest '.js-accordion' parent
                let active = document.activeElement;
                let first = accordion.querySelector('.js-accordion-header'); //todo: should be a variable declared in init
                let parent = active.closest('.js-accordion-item'); //todo: find a more robust method for this, should be a js-class
                let last = controls[controls.length - 1];
                switch(e.code) {
                    case 'ArrowDown':
                        e.preventDefault();
                        if (parent.nextElementSibling) {
                            parent.nextElementSibling.querySelector('.js-accordion-header').focus(); //todo: should be a variable declared in init
                        } else {
                            first.focus();
                        }
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        if (parent.previousElementSibling) {
                            parent.previousElementSibling.querySelector('.js-accordion-header').focus(); //todo: should be a variable declared in init
                        } else {
                            last.focus();
                        }
                        break;
                    case 'Home':
                        e.preventDefault();
                        first.focus();
                        break;
                    case 'End':
                        e.preventDefault();
                        last.focus();
                        break;
                }
            }

            function fireEvent(control, e) {

                const accordion = control.closest('.js-accordion'); // Get the nearest '.js-accordion' parent

                //If the Accordion has the class 'stayopen', or if no .js-accordion parent class is found, don't close the other accordion items
                if (accordion.getAttribute('data-stayopen') || !accordion) {
                    return;
                }

                // Get all opened accordion panels whose id does not match with the aria-controls attribute of the clicked accordion header // todo: We don't have to worry about looping through multiple aria-controls attributes here because accordion headers can never open more than 1 item at a time, but we should probably throw a warning for headers that have more than 1 string anyway
                const otherContents = accordion.querySelectorAll('.js-accordion-panel[data-disclosure-content=open]:not([id="' + control.getAttribute('aria-controls') + '"])');

                otherContents.forEach(function(otherContent) { // Iterate through all non-matching accordion items
                    otherContent.setAttribute('data-disclosure-content', 'closed'); // Update their states to 'closed'

                    let animation = otherContent.getAttribute('data-animate');

                    if (!animation) {
                        let parentElement = otherContent.closest('[data-animate]');
                        if (parentElement) {
                            animation = parentElement.getAttribute('data-animate');
                        }
                    }

                    Disclosure.prototype.SetAnimation.call(Disclosure.prototype, otherContent, animation);

                });

            }
        }
    }

    export { Accordion };
